import { render, staticRenderFns } from "./myOrders.vue?vue&type=template&id=7abc0b00"
import script from "./myOrders.vue?vue&type=script&lang=js"
export * from "./myOrders.vue?vue&type=script&lang=js"
import style0 from "./myOrders.vue?vue&type=style&index=0&id=7abc0b00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports